var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnedriveLogos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3999_43762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.15233 4.58219L9.15256 4.58136L14.1908 7.59921L17.193 6.33582C17.8031 6.07208 18.4609 5.93685 19.1255 5.9375C19.2362 5.9375 19.3457 5.94252 19.4546 5.94979C19.0936 4.54235 18.3317 3.27005 17.2613 2.28749C16.1909 1.30494 14.8581 0.65443 13.425 0.415022C11.9919 0.175613 10.5201 0.357611 9.18843 0.938899C7.85679 1.52019 6.72265 2.47574 5.92383 3.68943C5.94949 3.68911 5.97477 3.6875 6.00049 3.6875C7.11398 3.68599 8.2057 3.99589 9.15233 4.58219Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.15207 4.58137L9.15184 4.5822C8.20521 3.9959 7.11349 3.686 6 3.68751C5.97427 3.68751 5.94896 3.68912 5.92333 3.68944C4.8335 3.70293 3.76796 4.01314 2.84119 4.58674C1.91443 5.16033 1.16149 5.97562 0.663278 6.94499C0.165069 7.91436 -0.0595727 9.00117 0.0134948 10.0886C0.0865624 11.1761 0.454576 12.2231 1.07799 13.1171L5.52099 11.2474L7.49605 10.4163L11.8937 8.56566L14.1903 7.59921L9.15207 4.58137Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4532 5.94979C19.3443 5.94253 19.2349 5.9375 19.1241 5.9375C18.4595 5.93685 17.8018 6.0726 17.1918 6.33634L14.1895 7.59921L15.06 8.12067L17.9137 9.83L19.1588 10.5758L23.416 13.1258C23.8029 12.4077 24.0033 11.604 23.9991 10.7884C23.9948 9.97269 23.786 9.17113 23.3917 8.4571C22.9973 7.74306 22.4302 7.13937 21.7421 6.70133C21.054 6.26329 20.267 6.00488 19.4532 5.94979Z",
    fill: "#1490DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1598 10.5762L17.9147 9.83039L15.061 8.12107L14.1904 7.59961L11.8938 8.56604L7.49619 10.4166L5.52112 11.2478L1.07812 13.1175C1.63025 13.9113 2.36629 14.5597 3.22339 15.0073C4.08049 15.4549 5.03319 15.6884 6.00013 15.6879H19.1251C20.0051 15.6882 20.8688 15.4501 21.6245 14.9991C22.3801 14.5481 22.9995 13.9009 23.417 13.1262L19.1598 10.5762Z",
    fill: "#28A8EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3999_43762"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 15.375,
    fill: "white",
    transform: "translate(0 0.3125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnedriveLogos);
export default __webpack_public_path__ + "static/media/onedrive-logos.d5e71bb4d488089075537d5e8a6474af.svg";
export { ForwardRef as ReactComponent };